import { ProcessedFilters } from '@app/data/clients/rbServerSideClient/queries/GetSearchResults/types';
import { ExperienceType } from '@app/data/clients/rbServerSideClient/utils/constants';
import { constants, Drawer, Sheets } from '@redbubble/design-system';
import { useViewportWidth } from '@redbubble/next/hooks';
import { useIntl } from '@redbubble/next/intl';
import { AppProps, DeviceType } from '@redbubble/next/types';
import { usePageProps } from '@redbubble/next-provider';
import { FilterDrawerSettings } from 'pages/shop/types';
import { useEffect, useState } from 'react';
import { FilterSheet } from './FilterSheet';
import { Filters, StaticFilters } from './Filters';
import { FiltersProvider } from './FiltersContext';
import { messages } from './messages';

interface FiltersProps {
  filterDrawerSettings: FilterDrawerSettings;
  onClose: () => void;
  filters: ProcessedFilters;
  from: string;
  experience: ExperienceType;
}

export const FiltersContainer: React.FC<FiltersProps> = ({
  filterDrawerSettings,
  onClose,
  filters,
  from,
  experience,
}) => {
  const intl = useIntl();
  const { deviceType: initialDeviceType } = usePageProps<AppProps>();
  const { isOrAbove } = useViewportWidth(initialDeviceType);
  const [openProductSheet, setOpenProductSheet] = useState<boolean | undefined>(
    filterDrawerSettings.openProductSheet
  );

  useEffect(() => {
    setOpenProductSheet(filterDrawerSettings.openProductSheet);
  }, [filterDrawerSettings.openProductSheet]);

  const mapViewportToDrawerSize = () => {
    if (isOrAbove(DeviceType.Desktop)) {
      return constants.SMALL;
    }

    if (isOrAbove(DeviceType.Tablet)) {
      return constants.MEDIUM;
    }

    return constants.LARGE;
  };

  return (
    <FiltersProvider filters={filters} experience={experience}>
      <Drawer
        open={filterDrawerSettings.open}
        from={from}
        accessibleTitle={intl.formatMessage(messages.filters)}
        size={mapViewportToDrawerSize()}
        onCloseRequested={onClose}
      >
        {({ close }) => (
          <Sheets
            useAnimations={false}
            hideTitleBar
            sheets={{
              productSheet: (
                <FilterSheet
                  title={intl.formatMessage(messages.product)}
                  close={close}
                  onClose={onClose}
                >
                  <StaticFilters />
                </FilterSheet>
              ),
            }}
          >
            {({ openSheet }) => {
              if (openProductSheet) {
                openSheet('productSheet');
                setOpenProductSheet(false);
              }
              return (
                <FilterSheet
                  title={intl.formatMessage(messages.filters)}
                  openSheet={() => openSheet('productSheet')}
                  close={close}
                  onClose={onClose}
                  useAnimations={false}
                >
                  <Filters />
                </FilterSheet>
              );
            }}
          </Sheets>
        )}
      </Drawer>
    </FiltersProvider>
  );
};
